// AI Generated Test
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { SeoRepoService } from '../services/seo-repo.service';
import { MonLoadingService } from '@monsido/services/loading/services/loading.service';
import { BaseEntityService } from '@client/app/blocks/base/base.entity.service';
import { ENTITY_CONSTANT } from '@client/app/core/constants/entity.constant';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';
import { TranslateService } from '@client/app/services/translate/translate.service';

@Component({
    selector: 'seo-pages',
    templateUrl: './pages.component.html',
    styleUrls: [],
    standalone: false,
})
export class SeoPagesComponent extends BaseContainerComponentController implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    loading = false;
    pages: any[] = [];
    issues: any[] = [];
    totalPages = 0;

    // Properties required by BaseComponent and template
    promise: Promise<any> | null = null;
    exports: any[] = [];

    override currentSort: any = {
        by: 'priority_score',
        direction: 'desc',
    };
    eventId = 0;

    constructor (
        private seoRepoService: SeoRepoService,
        private loadingService: MonLoadingService,
        private baseEntityService: BaseEntityService,
        private translateService: TranslateService,
    ) {
        super({ table: true, labels: true, pages: true });
    }

    ngOnInit (): void {
        this.eventId = this.monEventsService.addListener(
            ENTITY_CONSTANT.PAGE_UPDATED_EVENT as any,
            this.baseEntityService.updateEntryInArray(this, 'pages', 'id'),
        );

        this.exports = [
            {
                name: this.translateService.getString('Issues by Page'),
                data: {
                    category: 'seo_pages',
                },
            },
        ];
        this.getPage(); // Load pages directly
    }

    ngOnDestroy (): void {
        if (this.eventId) {
            this.monEventsService.remove(this.eventId);
        }
        this.destroy$.next();
        this.destroy$.complete();
    }

    override async getPage (): Promise<void> {
        this.loading = true;
        this.loadingService.show();

        try {
            let params: any = {
                page: this.page, // Use BaseComponent's page property
                page_size: this.pageSize, // Use BaseComponent's pageSize property
                'types[]': ['html'], // Page type filter
                sort_by: this.currentSort.by === 'notification_count' ? 'seo_issues_count' : this.currentSort.by,
                sort_dir: this.currentSort.direction,
                search: this.search || null,
            };

            // Add search parameter if provided
            if (this.search) {
                params.search = this.search;
            }

            params = this.updateParamsWithIssuesFilters(params);
            params = this.updateParamsWithFilters(params);

            this.promise = this.seoRepoService.getAllPages(params).then((data) => {
                this.pages = data;
            }, () => {});

        } finally {
            this.loading = false;
            this.loadingService.hide();
        }
    }

    updateParamsWithIssuesFilters (params) {
        for (let i = 0; i < this.issues.length; i++) {
            params[this.issues[i].id] = true;
        }
        return params;
    }

    onFiltersChanges (filters: any): void {
        // Handle filter changes from pages-table component
        this.updateFilters(filters);

        if (filters.contains) {
            this.issues = filters.contains;
        } else {
            this.issues = [];
        }

        this.getPage();
    }
}
